import '../v1.2.0/css/globals-v120.css';
import { useState, useEffect } from 'react';
import Vector from '../v1.2.0/ui/Vector-49-9109';

function Logo(): React.JSX.Element {
  return (
    <div className="h-[25px] w-[111.571px]">
      <Vector />
    </div>
  );
}

interface BasicNavigationBarProps {
  onNavigate: (page: string) => void;
}

export function BasicNavigationBar({
  onNavigate,
}: BasicNavigationBarProps): React.JSX.Element {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = (): void => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll);
    return (): void => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="bg-navigationbar sticky top-0 z-50">
      <div
        className="h-[60px] px-4 flex items-center bg-navigationbar bg-[rgba(252,252,252,1)] transition-shadow duration-200"
        style={{ boxShadow: isScrolled ? '0 2px 8px rgba(0, 0, 0, 0.1)' : 'none' }}
      >
        <button
          className="cursor-pointer"
          onClick={() => onNavigate('/')}
          aria-label="Go to home"
        >
          <Logo />
        </button>
      </div>
    </div>
  );
}
